import { ActionFunction, redirect } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { formOrderNaming } from '../../../../../components/forms/NewWorkOrderForm/constants';

// Reutiliza los mismos passData y saveData de Work Orders
// ya que el flujo es identico (crear GenericOrder + Order)
import { passData } from '../../../workOrders/NewOrder/WorkOrderSummary/ActionUtils/passData';
import { saveData } from '../../../workOrders/NewOrder/WorkOrderSummary/ActionUtils/saveData';

export const ActionNewSurveillanceRouteOrderSummary: ActionFunction = async ({
  request,
  params,
}) => {
  const formData = await request.formData();
  const intent = formData.get('intent');

  if (intent === 'pass-data') {
    try {
      return passData(formData);
    } catch (err) {
      Sentry.captureException(err);
      console.error('Error in passData:', err);
    }
  }

  if (intent === 'save-data') {
    try {
      const dataFormRaw = sessionStorage.getItem(
        formOrderNaming.NEW_SURVEILLANCE_ROUTE_ORDER_FORM
      );
      // saveData creates the GenericOrder + Order and returns a `redirect(...)`
      // response pointing to `../{newOrderId}`, which is the workOrders context.
      // For surveillance routes we always want to land back on the parent route
      // detail, so we intercept the response and override the target URL.
      const result = await saveData(dataFormRaw);

      // saveData clears NEW_WORK_ORDER_FORM but not the SR-specific session key
      sessionStorage.removeItem(formOrderNaming.NEW_SURVEILLANCE_ROUTE_ORDER_FORM);

      const routeId = params.routeId;
      if (routeId && result instanceof Response) {
        return redirect(`/surveillance-route/${routeId}`);
      }
      return result;
    } catch (err) {
      Sentry.captureException(err);
      console.error('Error in saveData:', err);
    }
  }

  return null;
};
